import React, { useRef } from 'react';
import logo from ".././Header/Img/logo.svg"
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
function ViewInvoice({ booking, closeModal }) {
  const invoiceRef = useRef();
  if (!booking) return null;
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' }); // Get abbreviated month name
    const year = date.getFullYear().toString();

    return `${day} ${month} ${year}`;
  };
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent };
};
const noOfDays = booking?.noOfDays || 1;
const offerPrice = booking?.cottage?.offerPrice || 0;
const taxRate = booking?.cottage?.tax || 0;
const taxAmount = (offerPrice * noOfDays * taxRate) / 100;

  const url = 'uploads/';
  const downloadInvoice = async () => {
    const invoiceElement = invoiceRef.current;
    const canvas = await html2canvas(invoiceElement, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`Invoice_${booking._id}.pdf`);
  };

  const styles = {
    body: {
      fontFamily: "Arial, sans-serif",
      margin: "0",
      padding: "0",
      backgroundColor: "#F9F9F9",
      color: "#333",
    },
    logo: {
      marginBottom: "10px"
    },
    container: {
      maxWidth: "100%",
      background: "#fff",
      borderRadius: "8px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      overflow: "hidden",
      padding: "20px",
      fontSize: "14px",
    },
    header: {
      background: "#6C757D",
      color: "white",
      padding: "15px",
      textAlign: "center",
      fontSize: "18px",
      fontWeight: "bold",
    },
    section: {
      paddingTop: "20px",
    },
    info: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "20px",
    },
    infoItem: {
      fontSize: "14px",
      lineHeight: "1.5",
    },
    infoStrong: {
      fontSize: "14px",
    },
    tableCaption: {
      fontWeight: "600",
      fontSize: "16px",
      color: "#000",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "10px",
    },
    th: {
      textAlign: "left",
      padding: "10px",
      background: "#D9D9D9",
      fontWeight: "bold",
      border: "1px solid #ccc",
      fontSize: "14px",
      color: "#171845"
    },
    td: {
      textAlign: "left",
      padding: "10px",
      border: "1px solid #ccc",
      fontSize: "14px",
    },
    tdBottom: {
      color: "#fff",
      textAlign: "left",
      padding: "10px",
      border: "1px solid #ccc",
      fontSize: "14px"
    },
    totalRow: {
      fontWeight: "bold",
      background: "#6C757D",
      color: "white",
    },
    footer: {
      textAlign: "left",
      marginBottom: "10px",
      display: "flex",
      alignItems: "center",
      gap: "20px"
    },
    contact: {
      fontSize: "14px",
      marginBottom: "20px",
    },
    downloadBtn: {
      display: "block",
      width: "fit-content",
      margin: "0 auto",
      padding: "10px 20px",
      background: "#28A745",
      color: "white",
      textAlign: "center",
      textDecoration: "none",
      borderRadius: "4px",
      fontSize: "16px",
      fontWeight: "600",
    },
    paymentInfo: {
      paddingTop: "20px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "end"
    },
    downloadBtnHover: {
      background: "#218838",
    },
    headerRight: {
      textAlign: "right",
    },
    
  };
  return (
    <div className="modal fade viewbox edit-box show d-block" id="manufacturerModal" tabIndex={-1} aria-labelledby="manufacturerModal" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" >
          <div style={styles.container} ref={invoiceRef}>
            {/* Header */}
            <div style={styles.header}>Booking Invoice</div>
            {/* Details */}
            <div style={styles.section}>
              <div style={styles.info}>
                <div style={styles.infoItem}>
                  <div style={styles.logo}>
                    <img src={logo} alt="logo" />
                  </div>

                  <p>
                    <strong>RBrothers Real Estate & Construction Pvt Ltd</strong><br />
                    <strong>Ward No. 163333, Near Thakur Baba Mandir,</strong><br />
                    <strong>Gram Barri Jaithari Road, Anuppur,</strong><br />
                    <strong>484224 Madhya Pradesh India</strong><br />
                    <strong>support@greenheritageresort.com</strong><br />
                    <strong>+91 98765 43210</strong><br />
                    <strong>GSTIN: 23AAJCR4975P1ZL</strong>
                  </p>

                </div>
                <div style={styles.headerRight}>
                  <p>
                    <strong>Invoice Number:</strong> <strong>{booking?.bookingId}</strong>
                  </p>
                  <p>
                    <strong>Date:</strong> <strong>{formatDate(booking?.createdAt)}</strong>
                  </p>
                  <br />
                  <br />
                  <br />
                  <p>
                    <strong>Customer Name:</strong> <strong>{booking?.user?.name || booking?.investor?.name || 'N/A'}</strong>
                  </p>
                  <p>
                    <strong>Email:</strong> <strong>{booking?.user?.email || booking?.investor?.email || 'N/A'}</strong>
                  </p>
                  <p>
                    <strong>Address:</strong> <strong>{booking?.user?.city || booking?.investor?.city || 'N/A'}</strong>
                  </p>
                  <p>
                    <strong>Contact:</strong> <strong>{booking?.user?.mobileNo || booking?.investor?.mobileNo || 'N/A'}</strong>
                  </p>
                </div>
              </div>
            </div>
            <hr />
            {/* Booking Details */}
            <div style={styles.section}>
              <p style={styles.tableCaption}>Booking Details</p>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Cottage Name</th>
                    <th style={styles.th}>Check-in</th>
                    <th style={styles.th}>Check-out</th>
                    <th style={styles.th}>Guests</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={styles.td}>{booking?.cottage?.name}</td>
                    <td style={styles.td}>{formatDate(booking?.checkInDate)}</td>
                    <td style={styles.td}>{formatDate(booking?.checkOutDate)}</td>
                    <td style={styles.td}>{booking?.guestDetails.length}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* Package Detials */}
            <div style={styles.section}>
              <p style={styles.tableCaption}>Package Details</p>
              <table style={styles.table}>
                <tbody>
                  <tr>
                    <th style={styles.td}>Description</th>
                    <td style={styles.td} dangerouslySetInnerHTML={createMarkup(booking?.cottage?.description || 'N/A')}></td>
                  </tr>
                  <tr>
                    <th style={styles.td}>Amenities</th>
                    <td style={styles.td}>
                      <ul className="amenities">
                        {booking?.cottage?.swimmingPool && <li>Swimming Pool</li>}
                        {booking?.cottage?.wifi && <li>WiFi</li>}
                        {booking?.cottage?.ac && <li>Air Conditioning</li>}
                        {booking?.cottage?.parking && <li>Parking</li>}
                        {booking?.cottage?.livingArea && <li>Living Area</li>}
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* Itemized Charges */}
            <div style={styles.section}>
              <p style={styles.tableCaption}>Itemized Charges</p>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Description</th>
                    <th style={styles.th}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={styles.td}>Room Rate ({booking?.noOfDays} {booking?.noOfDays > 1 ? 'nights' : 'night'})</td>
                    <td style={styles.td}>{booking?.cottage?.offerPrice * booking?.noOfDays}</td>
                  </tr>
                  {/* <tr>
                    <td style={styles.td}>Service Fee</td>
                    <td style={styles.td}>{booking?.cottage?.name}</td>
                  </tr> */}
                  <tr>
                    <td style={styles.td}>Tax ({booking?.tax}%)</td>
                    <td style={styles.td}>{taxAmount}</td>
                  </tr>
                  <tr>
                    <td style={styles.td}>{booking?.coupon?.name ? `Discount (${booking?.coupon?.name})` : 'Discount'} </td>
                    <td style={styles.td}>-{booking?.discountAmount}</td>
                  </tr>
                  <tr style={styles.totalRow}>
                    <td style={styles.tdBottom}>Total</td>
                    <td style={styles.tdBottom}>{booking?.totalAmount}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* Payment Information */}
            <div style={styles.paymentInfo}>
              <div>
                <small>Payment Information</small>
                <p>
                  <strong>Status:</strong> {booking?.paymentStatus}
                </p>
              </div>
              <p>
                <strong>Paid via:</strong>{booking?.paymentmethod}
              </p>
            </div>
            <hr />
            {/* Footer */}
            <div>
              <div style={styles.footer}>
                <img src={logo} alt="logo" />
                <span>
                  Thank you for booking with Green Heritage Resort.
                  <br />
                  We hope you enjoy your stay!
                </span>
              </div>
              <hr />
              <div style={styles.contact}>
                For any queries, contact us at:{" "}
                <a href="mailto:support@greenheritageresort.com">
                  support@greenheritageresort.com
                </a>
              </div>
              <a href="#" style={styles.downloadBtn} onClick={downloadInvoice}>
                Download/Print Invoice
              </a>
            </div>

          </div>
          <div className="modal-footer d-flex">
            <button type="button" className="site-btn-green" style={{ marginBlock: '15px' }} onClick={closeModal}>
              CLOSE
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewInvoice;
